module.exports = __webpack_public_path__ + "img/_southafrica.ea09383a.png";